<template lang="html">
  <div tabindex="100" @keydown.up.prevent="onArrowUpPress" @keydown.down.prevent="onArrowDownPress">
    <usuario-fornecedor-filtros
    ref="filtros"
    @UsuarioFornecedorFiltros__AplicaFiltros="aplicaFiltros">
    </usuario-fornecedor-filtros>
    <v-card class="card-size">
      <v-card-title>
        <h2 class="headline mb-0" v-text="title">
        </h2>
      </v-card-title>
      <v-data-table :headers="headers" :items="registros" :options.sync="pagination" :item-class="onItemClass"
        :server-items-length="totalPage" :no-data-text="$t('label.tabela_sem_conteudo')" :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }">
        <template v-slot:item.acoes="{ item }">
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="podeEditar(item)" @click="edit(item)">
                <v-list-item-action>
                  <v-icon>edit</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.editar') }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="podeVisualizar(item)" @click="ver(item)">
                <v-list-item-action>
                  <v-icon>dehaze</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.visualizar') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="buscaDadosUltimaAlteracao(item)">
                <v-list-item-action>
                  <v-icon>app_registration</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.ultima_alteracao') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="buscaRelatorioLogUsuarioPorId(item)">
                <v-list-item-action>
                  <v-icon>get_app</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.exportar_log') }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="podeAprovarRepresentanteLegal(item.statusFluxo, item.indPossuiAnexos)"
                @click="openModalJustificativaAprovacao(item, 'APROVADO', $t('label.aprovar'))">
                <v-list-item-action>
                  <v-icon>thumb_up</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.aprovar') }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="podeReprovarRepresentanteLegal(item.statusFluxo)"
                @click="openModalJustificativaAprovacao(item, 'REPROVADO', $t('label.reprovar'))">
                <v-list-item-action>
                  <v-icon>thumb_down</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $t('label.reprovar') }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.indUsuarioExternoMaster && mostrarAcompanhamento(item)" @click="abrirAcompanhamento(item.idUsuario, item)">
                <v-list-item-action>
                  <v-icon>assignment_turned_in</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $tc('label.acompanhamento', 1) }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="limparWorkspaceFiltros(item.id)">
                <v-list-item-action>
                  <v-icon>filter_alt_off</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $tc('label.limpar_filtros', 1) }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="podeEditarDadosSensiveis(item)" @click="editDadosSensiveis(item)">
                <v-list-item-action>
                  <v-icon>manage_accounts</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ $tc('label.editar_dados_sensiveis', 1) }}</v-list-item-title>
              </v-list-item>
                <v-list-group
                  v-if="item.indPossuiTermoUso || item.indPossuiTermoNomeacao"
                  no-action
                  :value="false"
                  @click.stop
                >
                  <template v-slot:activator>
                    <v-list-item-action>
                      <v-icon>description</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>
                      {{ $t('label.termo_aceite') }}
                    </v-list-item-title>
                  </template>
                    <v-list-item
                    v-if="item.indPossuiTermoUso"
                    @click="prepararAbrirTermoAceite(item, 'termoUso')"
                    >
                    <v-list-item-action class="pl-6">
                      <v-icon>print</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{ $t('label.termo_uso') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    v-if="item.indPossuiTermoNomeacao"
                    @click="prepararAbrirTermoAceite(item, 'termoNomeacao')"
                    >
                    <v-list-item-action class="pl-6">
                      <v-icon>print</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{ $t('label.termo_nomeacao') }}</v-list-item-title>
                    </v-list-item>
                </v-list-group>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.icone_expiracao="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }" v-if="item.exibeIconeAviso && (item.dataVigenciaExpirada || item.dataVigenciaAExpirar)">
              <v-icon
              v-on="on"
              color="orange darken-1"
              dark>
                report_problem
              </v-icon>
            </template>
            <span>{{ item.dataVigenciaExpirada? $t('message.vigencia_expirada_usuario', { dataVigenciaExpirada : formatarData(item.dtaFimVigencia) })
                  : $t('message.alerta_termino_fim_vigencia_usuario', { dataFimVigencia : formatarData(item.dtaFimVigencia) }) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.nome_sobrenome="{ item }">
          {{ item.nomeSobrenome }}
        </template>
        <template v-slot:item.nom_estrutura_usuario="{ item }" v-if="isUsuarioLogadoFuncionario">
          {{ item.nomEstruturaUsuario }}
        </template>
        <template v-slot:item.grupofornecedor="{ item }">
          <template v-if="processarGrupos(item)"></template>

          <div v-if="item.gruposProcessados && item.gruposProcessados.length > 1">
            <v-menu offset-y :close-on-content-click="false" max-width="350" min-width="350" v-model="menuStates[item.id]">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on"><v-icon>visibility</v-icon></v-btn>
              </template>
              <v-card>
                <v-card-title class="py-2 subtitle-2">{{$t('label.grupos_fornecedores')}}</v-card-title>
                <v-list dense>
                  <v-list-item-group>
                    <v-list-item v-for="grupo in item.gruposProcessados" :key="grupo.id" class="py-0 my-0" dense>
                      <v-list-item-content class="py-0 my-0">
                        <div class="d-flex align-center">
                          <span class="grupo-texto">
                            {{ grupo.id }} - {{ grupo.nome?.toUpperCase().split(' ').map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(' ') }}
                          </span>

                          <v-tooltip bottom v-if="grupo.indRepConj">
                            <template v-slot:activator="{ on: tooltipOn }">
                              <v-icon
                                v-on="tooltipOn"
                                :color="getCorIconeRepConjunto(item, grupo)"
                                class="ml-2"
                              >
                                group
                              </v-icon>
                            </template>
                            <span>{{ getTooltipRepConjunto(grupo) }}</span>
                          </v-tooltip>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click.stop="closeMenu(item.id)" small>{{$t('label.fechar')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>

          <div v-else-if="item.gruposProcessados && item.gruposProcessados.length === 1">
            <span class="mr-1">{{ item.gruposProcessados[0].nome }}</span>
            <v-tooltip bottom v-if="item.gruposProcessados[0].indRepConj">
              <template v-slot:activator="{ on: tooltipOn }">
                 <v-icon v-on="tooltipOn" :color="getCorIconeRepConjunto(item, item.gruposProcessados[0])">
                  group
                </v-icon>
              </template>
              <span>{{ getTooltipRepConjunto(item.gruposProcessados[0]) }}</span>
            </v-tooltip>
          </div>

          <div v-else></div>
        </template>
        <template v-slot:item.indUsuarioExternoMaster="{ item }">
          <span>{{ item.indUsuarioExternoMaster ?
            $t('label.tipos_fornecedor.representante_legal') : $t('label.aprovador_autorizado') }}
          </span>
        </template>
        <template v-slot:item.indProcurador="{ item }">
          <span>{{ item.indUsuarioExternoMaster && item.indProcurador ? $t('label.sim') : '' }}</span>
        </template>
        <template v-if="podeVisualizarAnexos || podeCadastrarAnexos" v-slot:item.indPossuiAnexos="{ item }">
          <v-btn v-if="item.indUsuarioExternoMaster && item.indPossuiAnexos" icon @click="abrirModalAnexos(item)">
            <v-icon>visibility</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.statusFluxo="{ item }">
          <status v-if="item.indUsuarioExternoMaster && item.statusFluxo" :status="item.statusFluxo" :tooltip="item.statusFluxo"></status>
          <span v-else-if="!item.indUsuarioExternoMaster"><b>-</b></span>
        </template>
        <template v-slot:item.nomeUsuarioCriacao="{ item }">
          <span style="white-space: pre-line;">
            {{montaTextoCriacaoAlteracao(item.nomeUsuarioCriacao, item.dtaCriacao) }}
          </span>
        </template>
        <template v-slot:item.usuarioAlteracaoFlagAtivoInativo="{ item }">
          <span style="white-space: pre-line;">
            {{montaTextoCriacaoAlteracao(item.usuarioAlteracaoFlagAtivoInativo, item.dataAlteracaoFlagAtivoInativo) }}
          </span>
        </template>
      </v-data-table>
      <usuario-anexos-dialog ref="usuarioAnexosDialog" :pode-visualizar-anexos="podeVisualizarAnexos"
        :pode-cadastrar-anexos="podeCadastrarAnexos">
      </usuario-anexos-dialog>
    </v-card>
    <modal-dados-ultima-alteracao-usuario ref="modalDadosUltimaAlteracaoUsuario">
    </modal-dados-ultima-alteracao-usuario>
    <modal-lista-termos-aceite ref="modalListaTermosAceite">
    </modal-lista-termos-aceite>
    <usuario-aprovacao-dialog ref="modalJustificativaAprovacao" :title="titleJustificativaModal"
      :obrigatorio="statusAprovacaoUsuario !== 'APROVADO'" @Afirmativo="aprovarReprovarUsuario">
    </usuario-aprovacao-dialog>
    <modal-dados-fluxos-de-aprovacao-impactados-por-inativacao-usuario
      ref="modalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario"
      @agree="reprovarUsuarioComImpacto"
      :existe-fluxos-impactados-por-inativacao="existeFluxosImpactadosPorInativacao"
    >
    </modal-dados-fluxos-de-aprovacao-impactados-por-inativacao-usuario>
    <acompanhamento
      ref="modalAcompanhamento"
      :fluxo="statusPassos"
      :entidade="'REPRESENTANTE_LEGAL'"
    >
    </acompanhamento>
    <v-dialog v-model="dialogAcompanhamentoSemFluxo" max-width="600">
      <v-card>
        <v-card-title class="headline"> {{ $t('label.acompanhamento') }} </v-card-title>
        <v-card-text>
          {{ $t('message.usuario_ativado_sem_fluxo', { perfilAprovador: nomPerfilAprovador, usuarioAprovador: nomUsuarioAprovador}) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeModal">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">
import {
  mapGetters,
} from 'vuex';
import moment from 'moment';
import { removeEmptyProperties } from '@/common/functions/helpers';
import exportacao from '@/common/functions/exportacao';
import {
  forceHideLoading,
  forceLoading,
  skipLoading,
} from '@/common/functions/loading';
import { countRelatorioLogUsuario } from '@/common/resources/magalu-relatorios';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import { enviarEmailAvisoInativacaoFornecedor } from '@/common/resources/workflow-acao';
import Acompanhamento from '@/shared-components/workflow/Acompanhamento';
import ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario from '@/shared-components/ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario';
import Status from '@/shared-components/Status';
import UsuarioAnexosDialog from '@/spa/usuario/UsuarioAnexosDialog';
import UsuarioFornecedorFiltros from '@/spa/usuario/UsuarioFornecedorFiltros';
import ModalDadosUltimaAlteracaoUsuario from '@/shared-components/ModalDadosUltimaAlteracaoUsuario';
import ModalListaTermosAceite from '@/shared-components/ModalListaTermosAceite';
import UsuarioAprovacaoDialog from './UsuarioAprovacaoDialog';

export default {
  components: {
    UsuarioFornecedorFiltros,
    UsuarioAnexosDialog,
    ModalDadosUltimaAlteracaoUsuario,
    ModalListaTermosAceite,
    UsuarioAprovacaoDialog,
    Acompanhamento,
    Status,
    ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario,
  },
  data() {
    return {
      workspaceFiltrosResources: this.$api.workspaceFiltros(this.$resource),
      usuarioResources: this.$api.usuario(this.$resource),
      termoAceiteResources: this.$api.termoAceite(this.$resource),
      configSistemaResource: this.$api.configuracaoSistema(this.$resource),
      workflowAcaoResource: this.$api.workflowAcao(this.$resource),
      workflowApuracaoAcaoResource: this.$api.workflowApuracaoAcao(this.$resource),
      workflowContratoResource: this.$api.workflowContrato(this.$resource),
      headers: [
        {
          text: this.$tc('label.acoes', 2), sortable: false, align: 'center', value: 'acoes',
        },

        {
          text: this.$t('label.expiracao'), sortable: false, align: 'center', value: 'icone_expiracao',
        },
        { text: this.$t('label.nome'), sortable: true, value: 'nome' },
        { text: this.$t('label.email'), sortable: true, value: 'email' },
        { text: this.$tc('label.grupo_fornecedor', 1), value: 'grupofornecedor', sortable: true },
        {
          text: this.$tc('label.tipo_fornecedor', 1), value: 'indUsuarioExternoMaster', sortable: true, cellClass: 'nowrap',
        },
        { text: this.$tc('label.procurador', 1), value: 'indProcurador', sortable: true },
        { text: this.$tc('label.anexo', 2), value: 'indPossuiAnexos', sortable: true },
        {
          text: this.$tc('label.status_aprovacao', 1), value: 'statusFluxo', sortable: true, align: 'center',
        },
        {
          text: this.$tc('label.criado_por', 1), value: 'nomeUsuarioCriacao', sortable: true, align: 'center',
        },
        {
          text: this.$tc('label.ultima_alteracao_flag_ativacao', 1), value: 'usuarioAlteracaoFlagAtivoInativo', sortable: true, align: 'center',
        },
      ],
      workspace: {},
      entidadeWorkspace: 'gestao_usuario_fornecedor',
      pagination: {},
      totalPage: 0,
      esperar: false,
      registros: [],
      indSomenteUsuarioMaster: false,
      filtrosAplicados: {},
      indMinhasAprovacoesPendentes: false,
      bloquearExportacao: false,
      idPerfilAprovadorLegal: null,
      statusAprovacaoUsuario: '',
      titleJustificativaModal: '',
      usuarioAprovar: null,
      statusPassos: {},
      dialogAcompanhamentoSemFluxo: false,
      nomPerfilAprovador: '',
      nomUsuarioAprovador: '',
      rotasTermos: {
        termoNomeacao: 'verAceiteTermoNomeacao',
        termoUso: 'verAceiteTermoUso',
      },
      menuStates: {},
      dadosFluxosAprovacaoImpactados: {},
      existeFluxosImpactadosPorInativacao: false,
      indHabilitaAlterarFluxosImpactados: false,
      desabilitaFluxoAprovacaoUsuarioInativo: false,
      loading: true,
    };
  },
  props: {
    title: String,
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar(true);
      },
      deep: true,
    },
    indSomenteUsuarioMaster() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar(false);
      }, 500);
    },
    paginationSize(valor) {
      this.$emit('PAGINACAO_ALTERANDO_TAMANHO_PAGINA', valor);
    },
    indMinhasAprovacoesPendentes() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar(false);
      }, 500);
    },
  },
  computed: {
    ...mapGetters('implantacao', [
      'implantacao',
    ]),
    ...generateComputed('Usr', [
      'canAccessCRUD',
      'canSearch',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    isContentAvailable() {
      return !!this.tableData && !!this.tableData.length;
    },
    usuarioFilteredList() {
      return this.tableData.map((linha) => {
        const row = { ...linha };
        row.representante = {};
        row.representante.dependencias = this.stringToArray(linha);
        row.superioresImediatosArray = this.parseStringSuperioresImediatos(linha);
        row.canaisArray = this.parseStringCanal(linha);

        return row;
      });
    },
    filteredList() {
      return [];
    },
    isUsuarioLogadoExternoMaster() {
      return this.usuarioLogado.indUsuarioExternoMaster;
    },
    isUsuarioLogadoFuncionario() {
      return this.usuarioLogado.tipo === 'FUNCIONARIO';
    },
    isUsuarioLogadoFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
    podeVisualizarAnexos() {
      return this.canSearch;
    },
    podeCadastrarAnexos() {
      return this.canAccessCRUD && this.isUsuarioLogadoFuncionario;
    },
    cadastrarGestaoFornecedor() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CADASTRAR_GESTAO_DE_FORNECEDOR_MASTER' || el === 'USR_CADASTRAR_GESTAO_DE_FORNECEDOR_REPRESENTANTE_LEGAL').length;
    },
    consultarGestaoFornecedor() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CONSULTAR_GESTAO_DE_FORNECEDOR').length;
    },
    isAprovadorRepresentanteLegal() {
      return this.usuarioLogado.idPerfil === parseInt(this.idPerfilAprovadorLegal, 10);
    },
  },
  methods: {
    onItemClass(...args) {
      const [usuario] = args;
      return !usuario.indAtivo ? 'TableRow--disabled' : '';
    },
    formatarData(valor) {
      return moment(valor).format('DD/MM/YYYY');
    },
    buscar(trocaPagina) {
      this.loading = true;
      forceLoading();
      if (!trocaPagina) {
        this.pagination.page = 1;
      }
      const params = {
        ...this.filtrosAplicados,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      if (!this.isUsuarioLogadoFuncionario) {
        params.indUsuarioExterno = true;
      }

      if (params.colunaOrdenacao === 'nome') {
        params.colunaOrdenacao = 'u.nome';
      }

      if (params.colunaOrdenacao === 'indPossuiAnexos') {
        params.colunaOrdenacao = 'ind_possui_anexos';
      }

      if (params.colunaOrdenacao === 'indUsuarioExternoMaster') {
        params.colunaOrdenacao = 'representante_legal';
      }

      if (this.indSomenteUsuarioMaster) {
        params.indSomenteUsuarioMaster = this.indSomenteUsuarioMaster;
      }

      if (this.indMinhasAprovacoesPendentes) {
        params.indMinhasAprovacoesPendentes = this.indMinhasAprovacoesPendentes;
      }

      if (params.colunaOrdenacao === 'statusFluxo') {
        params.colunaOrdenacao = 'status_fluxo';
      }

      if (params.colunaOrdenacao === 'usuarioAlteracaoFlagAtivoInativo') {
        params.colunaOrdenacao = 'ind_ativo';
      }

      if (params.colunaOrdenacao === 'indProcurador') {
        params.colunaOrdenacao = 'ind_procurador';
      }

      params.indTabelaFornecedor = true;

      this.usuarioResources.listarUsuariosFornecedores(params).then((response) => {
        this.registros = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.loading = false;
        this.$refs.filtros.toggleFiltros();
        this.pararEsperar();
      }, (err) => {
        this.loading = false;
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    filtrar(trocaPagina) {
      if (this.esperar) return;
      this.esperar = true;
      forceLoading();
      setTimeout(() => {
        this.buscar(trocaPagina);
      }, 1000);
    },
    montaTexto(item) {
      if (!item) {
        return '';
      }
      const array = item.split('|');
      return (`${array[2]}`) || '';
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
        forceHideLoading();
      }, 2E2);
    },
    closeMenu(itemId) {
      this.$set(this.menuStates, itemId, false);
    },
    edit(row) {
      this.$emit('USUARIOTABELA_EDIT', row);
    },
    ver(row) {
      this.$emit('USUARIOTABELA_VER', row);
    },
    editDadosSensiveis(row) {
      this.$emit('USUARIOTABELA_EDIT_DADOS_SENSIVEIS', row);
    },
    stringToArray(linha) {
      const canaisVendaRepresentanteObj = !linha.canaisVendaRepresentante ? []
        : linha.canaisVendaRepresentante.split(',').map((cat) => {
          const canaisVendaRepresentanteStr = cat.split(':');
          return {
            id: parseInt(canaisVendaRepresentanteStr[0], 10),
            nomExtensao: canaisVendaRepresentanteStr[1],
            indAtivo: canaisVendaRepresentanteStr[2],
          };
        });

      return {
        canaisVenda: canaisVendaRepresentanteObj,
      };
    },
    abrirModalAnexos(item) {
      this.processarGrupos(item);
      this.$refs.usuarioAnexosDialog.open(item, item.gruposProcessados);
    },
    isUsuarioFornecedor(usuario) {
      return !!usuario.tipo && usuario.tipo === 'FORNECEDOR';
    },
    isUsuarioFornecedorMaster(usuario) {
      return usuario.indUsuarioExternoMaster;
    },
    podeEditar(usuario) {
      return this.canAccessCRUD && this.cadastrarGestaoFornecedor && (this.isUsuarioLogadoFuncionario
        || (this.isUsuarioFornecedor(this.usuarioLogado) && this.isUsuarioFornecedorMaster(this.usuarioLogado)
        && !this.isUsuarioFornecedorMaster(usuario)));
    },
    podeVisualizar(usuario) {
      return this.consultarGestaoFornecedor && !this.podeEditar(usuario);
    },
    podeEditarDadosSensiveis(usuario) {
      if (!this.getAllRoles) {
        return false;
      }
      const tenantsUsuario = usuario.tenant?.split(',').map((t) => t.trim()) ?? [];
      return !!this.getAllRoles
        .filter((el) => el === 'ALTERAR_DADOS_SENSIVEIS_USUARIO_FORNECEDOR').length && tenantsUsuario.length > 1;
    },
    buscaRelatorioLogUsuarioPorId(usuario) {
      const params = {
        id_usuario_selecionado: usuario.idUsuario ? usuario.idUsuario : usuario.id,
        ind_usuario_fornecedor: true,
      };
      let quantidadeRegistros = 0;

      countRelatorioLogUsuario(params, this.$resource)
        .then((response) => {
          quantidadeRegistros = response.data;
          if (quantidadeRegistros > this.limiteRegistrosExportacao) {
            this.$toast(this.$t('errors.registros.excede_limite_dados', { limite: this.limiteRegistrosExportacao }));
          } else if (quantidadeRegistros > 0) {
            this.requestExportacao(params, 'log_usuario_magalu', 'api');
          } else {
            this.$toast(this.$t('errors.registros.nao_ha_dados'));
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    requestExportacao(params, tipoRelatorio, modulo = 'api') {
      const filtroTratado = removeEmptyProperties(params);
      this.bloquearExportacao = true;

      exportacao.exportar(() => {
        this.bloquearExportacao = false;
      }, tipoRelatorio, this, filtroTratado, 5000, 0, modulo);
    },
    buscaDadosUltimaAlteracao(item) {
      const dados = {
        idUsuario: item.id,
      };
      setTimeout(() => this.$refs.modalDadosUltimaAlteracaoUsuario.open(dados), 2E2);
    },
    buscarChaveIDPerfilAprovadorLegal() {
      this.configSistemaResource.buscarChave({ chave: 'APROVADOR_USR_FORNE_REP_LEG' })
        .then((resp) => {
          this.idPerfilAprovadorLegal = resp.body;
        });
    },
    podeAprovarRepresentanteLegal(statusFluxo, indPossuiAnexos) {
      return this.isAprovadorRepresentanteLegal
        && statusFluxo && ['AGUARDANDO_APROVACAO', 'EM_ANALISE'].includes(statusFluxo) && indPossuiAnexos;
    },
    podeReprovarRepresentanteLegal(statusFluxo) {
      return this.isAprovadorRepresentanteLegal
        && statusFluxo && ['AGUARDANDO_APROVACAO', 'EM_ANALISE'].includes(statusFluxo);
    },
    openModalJustificativaAprovacao(item, status, titleModal) {
      this.dadosFluxosAprovacaoImpactados = {};
      this.existeFluxosImpactadosPorInativacao = false;
      this.indHabilitaAlterarFluxosImpactados = false;

      this.usuarioAprovar = item;
      this.titleJustificativaModal = titleModal;
      this.statusAprovacaoUsuario = status;
      this.statusAprovadoRepresentanteLegal = status;

      if (status !== 'REPROVADO') {
        this.$refs.modalJustificativaAprovacao.open();
        return;
      }
      const idUsuario = item.idUsuario || item.id;
      forceLoading();
      this.buscaFluxoAprovacaoImpactados(idUsuario);
    },
    buscaFluxoAprovacaoImpactados(idUsuario) {
      this.usuarioResources.dadosFluxosAprovacaoImpactados({ idUsuario })
        .then((res) => {
          forceHideLoading();
          const dados = res.body;
          this.dadosFluxosAprovacaoImpactados = {};
          this.existeFluxosImpactadosPorInativacao = false;

          if (dados && Object.keys(dados).length > 0) {
            this.dadosFluxosAprovacaoImpactados = dados;
            this.dadosFluxosAprovacaoImpactados.idsCampanha = dados.idsCampanha && dados.idsCampanha.length ? dados.idsCampanha.split(',').map(Number) : [];
            this.dadosFluxosAprovacaoImpactados.idsApuracao = dados.idsApuracao && dados.idsApuracao.length ? dados.idsApuracao.split(',').map(Number) : [];
            this.dadosFluxosAprovacaoImpactados.idsContrato = dados.idsContrato && dados.idsContrato.length ? dados.idsContrato.split(',').map(Number) : [];
            this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto = dados.idsContratoRepresentacaoConjunto && dados.idsContratoRepresentacaoConjunto.length ? dados.idsContratoRepresentacaoConjunto.split(',').map(Number) : [];

            if (this.dadosFluxosAprovacaoImpactados.idsCampanha.length > 0
             || this.dadosFluxosAprovacaoImpactados.idsApuracao.length > 0
             || this.dadosFluxosAprovacaoImpactados.idsContrato.length > 0
             || this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto.length > 0) {
              this.existeFluxosImpactadosPorInativacao = true;
            }
          }

          if (this.existeFluxosImpactadosPorInativacao) {
            const modalData = {
              idUsuario,
              nomeFornecedor: this.usuarioAprovar.nomeSobrenome || `${this.usuarioAprovar.nome} ${this.usuarioAprovar.sobrenome}`,
              dadosFluxosAprovacaoImpactados: this.dadosFluxosAprovacaoImpactados,
              indReprovacaoUsuarioFornecedorMaster: true,
            };
            this.$refs.modalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario.open(modalData);
          } else {
            this.$refs.modalJustificativaAprovacao.open();
          }
        })
        .catch((err) => {
          forceHideLoading();
          this.$error(this, err);
        });
    },
    aprovarReprovarUsuario(justificativa) {
      const objArmazenamento = {
        ...this.usuarioAprovar,
      };
      objArmazenamento.statusFluxo = this.statusAprovacaoUsuario;
      objArmazenamento.justificativaAprovacao = justificativa;
      if (this.statusAprovacaoUsuario === 'APROVADO' && objArmazenamento.indUsuarioExternoMaster
        && !objArmazenamento.indProcurador) {
        const hoje = this.moment();
        objArmazenamento.dtaInicioVigencia = hoje.format('YYYY-MM-DD');
        objArmazenamento.dtaFimVigencia = hoje.clone().add(1, 'year').format('YYYY-MM-DD');
      }
      forceLoading();
      this.usuarioResources.aprovarUsuarioMaster({ id: objArmazenamento.id }, objArmazenamento)
        .then(() => {
          if (this.existeFluxosImpactadosPorInativacao) {
            if (this.indHabilitaAlterarFluxosImpactados && this.desabilitaFluxoAprovacaoUsuarioInativo) {
              skipLoading();
              Promise.all([
                this.enviarAcoesParaAnalise(),
                this.enviarApuracoesParaAnalise(),
                this.enviarContratosParaAnalise(),
              ]).then(() => {
                this.enviaEmailAvisoInativacao();
                this.dadosFluxosAprovacaoImpactados = {};
                this.indHabilitaAlterarFluxosImpactados = false;
                forceHideLoading();
                this.filtrar(false);
                this.$toast(this.$t('message.atualizado_com_sucesso'));
              }).catch((err) => {
                forceHideLoading();
                this.$error(this, err);
              });
            } else {
              forceHideLoading();
              this.filtrar(false);
              this.$toast(this.$t('message.atualizado_com_sucesso'));
            }
          } else {
            forceHideLoading();
            this.filtrar(false);
            this.$toast(this.$t('message.atualizado_com_sucesso'));
          }
        })
        .catch((err) => {
          forceHideLoading();
          this.$toast(err.data.error);
        });
    },
    reprovarUsuarioComImpacto(justificativa, indReprovacaoUsuarioFornecedorMaster) {
      if (indReprovacaoUsuarioFornecedorMaster) {
        this.indHabilitaAlterarFluxosImpactados = true;
        this.aprovarReprovarUsuario(justificativa);
      }
    },
    enviarAcoesParaAnalise() {
      const nomeFornecedor = this.usuarioAprovar.nomeSobrenome || `${this.usuarioAprovar.nome} ${this.usuarioAprovar.sobrenome}`;
      const listaAcoes = this.dadosFluxosAprovacaoImpactados.idsCampanha;
      const horaInativacao = this.pegaDataAtual();
      const promises = [];
      if (listaAcoes.length) {
        listaAcoes.forEach((idAcao) => {
          const params = {
            idAcao,
            observacao: this.$t('message.enviado_analise_automaticamente_por_inativacao_fornecedor', { nomeFornecedor, horaInativacao }),
          };
          const promise = this.workflowAcaoResource.enviarAnaliseAcaoPorInativacaoFornecedor(params, params)
            .then(() => {})
            .catch((err) => {
              this.$error(this, err);
            });
          promises.push(promise);
        });
      }
      return Promise.all(promises);
    },

    enviarApuracoesParaAnalise() {
      const nomeFornecedor = this.usuarioAprovar.nomeSobrenome || `${this.usuarioAprovar.nome} ${this.usuarioAprovar.sobrenome}`;
      const listaApuracoes = this.dadosFluxosAprovacaoImpactados.idsApuracao;
      const horaInativacao = this.pegaDataAtual();
      const promises = [];
      if (listaApuracoes.length) {
        listaApuracoes.forEach((idApuracao) => {
          const params = {
            idApuracao,
            observacao: this.$t('message.enviado_analise_automaticamente_por_inativacao_fornecedor', { nomeFornecedor, horaInativacao }),
          };
          const promise = this.workflowApuracaoAcaoResource.enviarAnaliseApuracaoPorInativacaoFornecedor(params, params)
            .then(() => {})
            .catch((err) => {
              this.$error(this, err);
            });
          promises.push(promise);
        });
      }
      return Promise.all(promises);
    },

    enviarContratosParaAnalise() {
      const nomeFornecedor = this.usuarioAprovar.nomeSobrenome || `${this.usuarioAprovar.nome} ${this.usuarioAprovar.sobrenome}`;
      const listaContratos = this.dadosFluxosAprovacaoImpactados.idsContrato;
      const horaInativacao = this.pegaDataAtual();
      const promises = [];
      if (listaContratos.length) {
        const promise = listaContratos.forEach((idContrato) => {
          const params = {
            idContrato,
            observacao: this.$t('message.enviado_analise_automaticamente_por_inativacao_fornecedor', { nomeFornecedor, horaInativacao }),
          };
          this.workflowContratoResource.enviarAnaliseContratoPorInativacaoFornecedor(params, params)
            .then(() => {})
            .catch((err) => {
              this.$error(this, err);
            });
        });
        promises.push(promise);
      }
      return Promise.all(promises);
    },
    buscarChaveDesabilitarFluxoAprovacaoUsuarioInativo() {
      this.configSistemaResource.buscarChave({ chave: 'DESABILITAR_FLUXO_APROVACAO_USUARIO_INATIVO' })
        .then((resp) => {
          this.desabilitaFluxoAprovacaoUsuarioInativo = resp.body;
        });
    },
    enviaEmailAvisoInativacao() {
      const idUsuario = this.usuarioAprovar.idUsuario || this.usuarioAprovar.id;
      const params = {
        listaCampanhas: this.dadosFluxosAprovacaoImpactados.idsCampanha,
        listaApuracoes: this.dadosFluxosAprovacaoImpactados.idsApuracao,
        listaContratos: this.dadosFluxosAprovacaoImpactados.idsContrato,
        idUsuario,
      };

      enviarEmailAvisoInativacaoFornecedor(params, this.$resource).then(() => {})
        .catch((err) => {
          this.$error(this, err);
        });
    },
    pegaDataAtual() {
      const dataAtual = new Date();
      const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      };
      const horaInativacao = dataAtual.toLocaleString('pt-BR', options);
      return horaInativacao;
    },
    mostrarAcompanhamento(item) {
      return item.statusFluxo && item.statusFluxo !== 'EM_CADASTRO' && item.statusFluxo !== 'CANCELADO';
    },
    aplicaFiltros(filtros = {}) {
      if (Object.keys(filtros).length > 0) {
        this.filtrosAplicados = filtros;
      } else {
        this.filtrosAplicados = {};
      }
      this.filtrar(false);
    },
    limparWorkspaceFiltros(idUsuario) {
      const entidade = this.entidadeWorkspace;
      const params = {
        entidade,
        idUsuario,
      };
      this.workspaceFiltrosResources
        .limpar(params, params)
        .then(() => {
          this.$toast(this.$t('message.filtros_removidos'));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    abrirAcompanhamento(idUsuario, item) {
      if (item.indAtivadoPeloAprovador) {
        this.nomPerfilAprovador = item.nomPerfilAprovador;
        this.nomUsuarioAprovador = item.nomUsuarioAprovador;
        this.dialogAcompanhamentoSemFluxo = true;
      } else {
        this.usuarioResources.buscarFluxoAprovacao({ idUsuario })
          .then((res) => {
            this.statusPassos = res.data;
            if (this.statusPassos.passos) {
              const passo = this.statusPassos.passos.find((e) => e.statusPasso === 'AGUARDANDO_APROVACAO');
              if (passo) {
                passo.isProximoPasso = true;
              }
            }
            setTimeout(() => this.$refs.modalAcompanhamento.open());
          })
          .catch((err) => {
            this.$toast(err.data.error);
          });
      }
    },
    prepararAbrirTermoAceite(usuario, tipoTermo) {
      const idUsuario = usuario.id;
      let tipoUsuario = '';
      if (usuario.indUsuarioExternoMaster) {
        tipoUsuario = 'REPRESENTANTE_LEGAL';
      } else {
        tipoUsuario = 'APROVADOR_AUTORIZADO';
      }

      const gruposUsuarioLogado = this.usuarioLogado.idsGrupoFornecedor || [];
      let idsGruposUsuarioCadastrado = [];

      if (Array.isArray(usuario.idsGrupoFornecedor)) {
        idsGruposUsuarioCadastrado = usuario.idsGrupoFornecedor;
      } else if (typeof usuario.idGrupoFornecedor === 'string') {
        idsGruposUsuarioCadastrado = usuario.idGrupoFornecedor.split(',').map((s) => Number(s.trim()));
      }

      let idsParaFiltrar = [];
      if (this.isUsuarioLogadoFornecedor) {
        idsParaFiltrar = idsGruposUsuarioCadastrado.filter((id) => gruposUsuarioLogado.includes(id));
        if (idsParaFiltrar.length === 0) {
          this.$toast.warning(this.$t('message.sem_termos_visualizacao'));
          return;
        }
      }

      const params = {
        idUsuario,
        tipoTermo,
        tipoUsuario,
        idsGruposCadastrados: this.isUsuarioLogadoFuncionario ? idsGruposUsuarioCadastrado : idsParaFiltrar,
      };

      this.termoAceiteResources.buscarAceitesUsuarioPorGrupo(params)
        .then((response) => {
          const termos = response.data;
          this.abrirTermoAceiteUsuario(tipoUsuario, tipoTermo, termos);
        }, (err) => this.$error(this, err));
    },
    abrirTermoAceiteUsuario(tipoUsuario, tipoTermo, termos) {
      if (this.isUsuarioLogadoFornecedor && (tipoUsuario !== 'REPRESENTANTE_LEGAL' && tipoTermo !== 'termoNomeacao')) {
        const route = this.$router.resolve({
          name: this.rotasTermos[tipoTermo],
          params: { idAceite: termos[0].id },
        });
        window.open(route.href, '_blank');
      } else {
        this.$refs.modalListaTermosAceite.open(termos, tipoTermo);
      }
    },
    closeModal() {
      this.nomPerfilAprovador = '';
      this.nomUsuarioAprovador = '';
      this.dialogAcompanhamentoSemFluxo = false;
    },
    processarGrupos(item) {
      if (item.gruposProcessados) return true;

      const nomesStr = item.nomeGrupoFornecedor || '';
      const repConjElegivelStr = item.indGrupoPossuiRepresentacaoConjunto || '';
      const nomesArray = nomesStr.split(',').map((s) => s.trim()).filter((s) => s);

      const grupoInfoMap = new Map();
      repConjElegivelStr.split(',').forEach((s) => {
        const parts = s.trim().split(' - ').map((p) => p.trim());
        const idKey = parts[0];
        const flagRepConj = parts[1]?.toLowerCase() === 'true';
        const flagElegivel = parts[2]?.toLowerCase() === 'elegivel';
        grupoInfoMap.set(idKey, { indRepConj: flagRepConj, isElegivel: flagElegivel });
      });

      item.gruposProcessados = nomesArray.map((nomeCompleto) => {
        const idNomeParts = nomeCompleto.split(' - ');
        const idGrupo = idNomeParts[0].trim();
        const nome = idNomeParts.length > 1 ? idNomeParts.slice(1).join(' - ').trim() : idGrupo;

        const info = grupoInfoMap.get(idGrupo);
        const indRepConjFinal = info ? info.indRepConj : false;
        const isElegivelFinal = info ? info.isElegivel : false;

        return {
          id: parseInt(idGrupo, 10),
          nome,
          indRepConj: indRepConjFinal,
          isElegivel: isElegivelFinal,
        };
      }).filter((g) => !Number.isNaN(g.id));

      return true;
    },
    getCorIconeRepConjunto(item, grupo) {
      if (!grupo.indRepConj) {
        return 'secondary lighten-2';
      }

      const elegivelParaVerde = this.isUsuarioLogadoFuncionario
       && item.indUsuarioExternoMaster && grupo.isElegivel;

      if (elegivelParaVerde) {
        return 'green';
      }

      return 'secondary lighten-2';
    },

    getTooltipRepConjunto(grupo) {
      return grupo.isElegivel ? this.$t('label.representacao_conjunto_grupo_elegivel') : this.$t('label.representacao_conjunto');
    },
    montaTextoCriacaoAlteracao(usuario, dataHorario) {
      if (!usuario || !dataHorario) {
        return '';
      }
      const [data, hora] = dataHorario.split(' ');
      return this.$t('message.usuario_data_horario', { usuario, data, hora });
    },
  },
  mounted() {
    forceLoading();
    const promises = [];
    promises.push(this.buscarChaveIDPerfilAprovadorLegal());
    promises.push(this.buscarChaveDesabilitarFluxoAprovacaoUsuarioInativo());
    Promise.all(promises)
      .then()
      .catch((err) => {
        this.$error(this, err);
      });
  },
};
</script>
